import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const ReportsServicesWithoutServicesList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsServicesWithoutService/ReportsServicesWithoutServiceList/ReportsServicesWithoutServiceList"
    )
);
export const ReportsServicesWithoutServices = () => {
  return (
    <Layout>
      <ReportsServicesWithoutServicesList />
    </Layout>
  );
};
